<dashboard-tag-edit
    [values]="tag$ | async"
    [tagProtocols]="protocols"
    [orgProtocols]="all"
    [nonOrgProtocols]="all"
    (eventBus)="handleEventBus($event)"
></dashboard-tag-edit>
